module.exports = __webpack_public_path__ + "static/img/048江城政协app.451319e.png";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/048江城政协app.png
// module id = Sdcl
// module chunks = 0